import { DialogService } from 'src/app/services/dialog.service';
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogFormService } from 'src/app/services/dialog-form.service';
import { FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { LicenceType } from 'src/app/models/licence-type';
import { LicenceStatus } from 'src/app/models/licence-status';
import { ShareClientId } from 'src/app/services/data/companies.service';
import { LicenceDto } from 'src/app/models/licenceDto';

@Component({
  selector: 'app-dialog-licence-form',
  templateUrl: './dialog-licence-form.component.html',
  styleUrl: './dialog-licence-form.component.scss',
})
export class DialogLicenceFormComponent implements OnInit {
  @Input()
  form!: FormGroup;

  @Input()
  initialLicence: LicenceDto | undefined;

  licenceTypes: LicenceType[] = [];
  licenceStatuses: LicenceStatus[] = [];

  isSuspended: boolean = false

  constructor(
    private dialogFormService: DialogFormService,
    public dataService: DataService,
    private shareClientId: ShareClientId
  ) {
    // Form is passed as @Input, don't initialize it here
  }

  async ngOnInit(): Promise<void> {
    this.form.valueChanges.subscribe((licence) => {
      if (this.form.valid) {
        this.shareClientId.currentLicence = licence;
      }
    });

    this.form.get("status")?.valueChanges.subscribe(status => {
      this.isSuspended = status == 2
    })

    this.form.get("opex")?.valueChanges.subscribe(opex => {
      console.log("EXEC OPEX ", opex)
      if (opex) {
        this.form.get("offline")?.setValue(false);
        this.form.get("offline")?.disable();
      } else {
        this.form.get("offline")?.enable();
      }
    })

    await new Promise((r) => {
      setTimeout(r, 200);
    });
    this.dataService.licenceTypes.forEach((val) => {
      if (val.active !== false) {
        this.licenceTypes.push(val);
      }
    });
    this.dataService.licenceStatuses.forEach((val) =>
      this.licenceStatuses.push(val)
    );
    if (this.initialLicence) {
      this.form.get('vrs')?.setValue(this.initialLicence?.vrs);
      this.form.get('vrs')?.markAsTouched();
      this.form.get('vrs')?.updateValueAndValidity();

      this.form.get('projectName')?.setValue(this.initialLicence?.project);
      this.form.get('projectName')?.markAsTouched();
      this.form.get('projectName')?.updateValueAndValidity();

      this.form.get('type')?.setValue(this.initialLicence?.licence_type_id);
      this.form.get('status')?.setValue(this.initialLicence?.licence_status_id);
      this.form.get('opex')?.setValue(this.initialLicence?.opex ?? false);
      this.form.get('offline')?.setValue(this.initialLicence?.offline ?? false);
      this.form.get('projectNumber')?.setValue(this.initialLicence?.project_number ?? '');
      this.form.get('easybillDocumentNumber')?.setValue(this.initialLicence?.easybill_document_number ?? '');
      this.form.get('easybillDocumentDate')?.setValue(
        this.initialLicence?.easybill_document_date
          ? this.initialLicence.easybill_document_date.split('T')[0]
          : ''
      );
      this.form.get('customerOrderNumber')?.setValue(this.initialLicence?.customer_order_number ?? '');

      // Mark the entire form as touched to trigger validation
      this.form.markAllAsTouched();
    }
  }

  generateVrsNumber() {
    this.form.get("vrs")?.setValue(crypto.randomUUID());
    this.form.get("vrs")?.markAsDirty();
  }

  undoChanges(formControlName: string, value?: string | number) {
    if (value) {
      this.form.get(formControlName)?.setValue(value);
    } else {
      this.form.get(formControlName)?.setValue("")
    }
  }
}
